module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Software Development and Information Technology Company that provides software solutions, products and platforms to e-commerce, and other e-business industries in the middle east.","links":"Navigation:","resources":{"subheader":"Checkout our resources","github":"Github"}}}')
  delete Component.options._Ctor
}
